module.exports = __webpack_public_path__ + "img/LogoCZ.dc27fa00.png";